import axios from 'axios';
import {
  DISCOUNT_BLACKLIST_URL,
  DISCOUNT_BOTTOM_PRICE_URL,
  DISCOUNT_SETTINGS_URL,
} from 'api/constants';
import { createErrorFromAxiosMultipleErrors } from 'api/utilities';

export async function getDiscountBlacklist() {
  try {
    return await axios.get(DISCOUNT_BLACKLIST_URL);
  } catch (error) {
    throw createErrorFromAxiosMultipleErrors(error);
  }
}

export async function putDiscountBlacklist(file) {
  try {
    const formData = new FormData();
    formData.append('blacklist', file);

    return await axios.put(DISCOUNT_BLACKLIST_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  } catch (error) {
    throw createErrorFromAxiosMultipleErrors(error);
  }
}

export async function getDiscountSettings() {
  try {
    return await axios.get(DISCOUNT_SETTINGS_URL);
  } catch (error) {
    throw createErrorFromAxiosMultipleErrors(error);
  }
}

export async function putDiscountSettings(file) {
  try {
    const formData = new FormData();
    formData.append('discount_schemes', file);

    return await axios.put(DISCOUNT_SETTINGS_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  } catch (error) {
    throw createErrorFromAxiosMultipleErrors(error);
  }
}

export async function putDiscountBottomPrice(bottomPrice, type) {
  try {
    const payload = {
      bottom_price: bottomPrice,
      type,
    };
    return await axios.put(DISCOUNT_BOTTOM_PRICE_URL, payload);
  } catch (error) {
    throw createErrorFromAxiosMultipleErrors(error);
  }
}
